import { render, staticRenderFns } from "./LabelTip.vue?vue&type=template&id=597d64d0&scoped=true"
import script from "./LabelTip.vue?vue&type=script&lang=js"
export * from "./LabelTip.vue?vue&type=script&lang=js"
import style0 from "./LabelTip.vue?vue&type=style&index=0&id=597d64d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d64d0",
  null
  
)

export default component.exports